import { getPersisted } from '../root.selectors'

export const getPersistedSession = (state) => getPersisted(state).session
export const getPersistedOTP = (state) => getPersisted(state).OTP
export const getNeededBuildUpdate = (state) => getPersisted(state).neededBuildUpdate
export const getOpenedPages = (state) => getPersisted(state).openedPages
